<template>
  <div class="app-container">
    <header>
      <el-col :span="18">
        <el-row>
          <span>模式：{{ $route.params.modeDesc }}</span>
          <span class="ml-20">故事：{{ $route.params.storyName }}</span>
          <span class="ml-20">角色：{{ $route.params.role }}</span>
        </el-row>
      </el-col>
      <el-col :span="6">
        <el-button @click="cancel">取消</el-button>
        <el-button @click="onSubmit('ruleForm')">提交</el-button>
      </el-col>

    </header>
    <el-form ref="ruleForm" label-width="120px">
      <div v-for="(val,key) in paramMap" :key="key">
        <div class="title">{{ key }}</div>
        <el-form-item
          v-for="(item,index) in val"
          :key="index"
          :label="item.name"
        >
          <el-input :id="`textarea${key}${index}`" v-model="item.value" type="textarea" :placeholder="`请输入${item.name}`" @input="changeTextarea(`textarea${key}${index}`)" />
          <!-- :rules="{ required: true, message: `请输入${item.name}`, trigger: 'change' }" -->
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import { getExerciseDetail, updateExerciseDetail } from '@/api/exercise'

export default {
  data() {
    return {
      id: '',
      paramMap: null,
      detailData: null,
      textareaId: ''
    }
  },
  created() {
    console.log('params', this.$route.params)
    this.id = this.$route.params.id
    this.getDetail()
  },

  updated() {
    !this.textareaId && this.$nextTick(() => {
      var textarea = document.getElementsByTagName('textarea')
      console.log('target', textarea)
      textarea.forEach(item => {
        item.style.height = item.scrollHeight + 'px'
      })
    })
    this.textareaId && this.$nextTick(() => {
      var textarea = document.getElementById(this.textareaId)
      textarea.style.height = textarea.scrollHeight + 'px'
    })
  },
  methods: {
    changeTextarea(val) {
      this.textareaId = val
    },
    getDetail() {
      getExerciseDetail({ id: this.id }).then(res => {
        console.log('detail', res)
        this.detailData = res.data
        this.paramMap = res.data.paramMap
      })
    },
    onSubmit() {
      // const params = {
      //   mode: this.detailData.mode,
      //   promptId: this.detailData.promptId,
      //   roleType: this.detailData.roleType,
      //   paramMap: {}
      // }
      // Object.keys(this.paramMap).forEach(key => {
      //   params.paramMap[key] = []
      //   this.paramMap[key].filter(item => item.value).forEach(arr => {
      //     params.paramMap[key].push(arr)
      //   })
      // })
      updateExerciseDetail(this.detailData).then(() => {
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.$router.go(-1)
      })
    },

    cancel() {
      this.$router.go(-1)
    }
  }

}
</script>

<style lang="scss" scoped>
::v-deep{
  .el-form{
    flex: 1;
    overflow: auto;
  }
  .el-form-item {
    width: 100%;
  }
  .el-textarea__inner{
    resize: none;
  }
  .el-select{
    width: 100%;
  }
  .el-button:last-child{
    background-color: #419eee;
    color: #fff;
    border: 1px solid #419eee;
  }
  .el-row{
    text-align: left;
  }
}
header{
  text-align: right;
  .ml-20{
    margin-left: 20px;
  }
}
.title{
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 10px;
}
</style>

